import { AnyAction } from 'redux';
import { FORGOT_PASSWORD_FAILURE, FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_SUCCESS, RESET_VALIDATION_MESSAGE } from '../constants/auth.constant';

const initialState = {
    loading: false,
    data: [],
    errMsg: '',
};

export const forgotPasswordReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                errMsg: '',
            };
        case FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                errMsg: action.payload,
            };
        case RESET_VALIDATION_MESSAGE:
            return {
                ...state,
                loading: false,
                data: [],
                errMsg: '',
            };
        default:
            return state;
    }
};
